import React from "react";
import Alert from '@mui/material/Alert';
import { Info } from "@mui/icons-material";

const AlertMessage = ({ text,  }) => {
    const alertStyle = {display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px"}
    return(
        <Alert icon={<Info fontSize="inherit" />} severity="error" sx={alertStyle}>
        {text}
        </Alert>
    )
};

export default AlertMessage;